import React, { useEffect, useRef, useState } from "react";
import { CircularIndeterminate, FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { SFHabitacionGet } from "services/services-mia/SFHabitacionGet";
import { SFHabitacionDel } from "services/services-mia/SFHabitacionDel";

export default function DeleteModal({ user, updateList, closeModal, setterRowSelected }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const [data, setData] = useState();
    const formikRef = useRef();

    useEffect(() => {
        (async () => {
            const result = await SFHabitacionGet(credentials, { SFHabitacionId: user.id });
            const habitacion = result?.[0];
            if (!habitacion?.SFHabitacionId) return;

            formikRef.current.setValues({
                numero: habitacion.SFHabitacionNumero,
                piso: habitacion.SFHabitacionPiso,
            });
            setData(habitacion);
        })();
    }, [credentials, user.id]);

    const handleDelete = async () => {
        setInRequest(true);
        const response = await SFHabitacionDel(credentials, {
            SFHabitacionId: data.SFHabitacionId,
        });
        setInRequest(false);
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Habitación eliminada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            setterRowSelected({ status: false, row: {} });
            closeModal();
        }
    };

    return (
        <Formik
            innerRef={formikRef}
            initialValues={{ numero: "", piso: "" }}
            onSubmit={handleDelete}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles.column} style={{ maxWidth: "400px", margin: "0 auto" }}>
                    <FormikTextInput name="numero" labelText="Número" disabled />
                    <FormikTextInput name="piso" labelText="Piso" disabled />
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                    {inRequest && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}
